import React, { useEffect, useRef, useState } from "react";
import "../css/OtpScreen.css";
import { Button } from "semantic-ui-react";

const OtpScreen = ({
  otpSubmitHandler,
  mobileNo,
  btnText,
  resendDisabled,
  setResendDisabled,
  sendOtpHandler,
  loading,
  otp,
  setOtp
}) => {
  // const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = [
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
  ];
  const [timer, setTimer] = useState(30);

  useEffect(() => {
    let intervalId;
    if (resendDisabled) {
      intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [resendDisabled]);

  useEffect(() => {
    if (timer === 0) {
      setResendDisabled(false);
      setTimer(30);
    }
  }, [timer]);

  const handleInputChange = (index, value) => {
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < 6 && value.length === 1) {
        inputRefs[index + 1].current.focus();
      }
      if (index > 0 && value.length === 0) {
        inputRefs[index - 1].current.focus();
      }
    }
  };

  const submitOtpHandler = () => {
    otpSubmitHandler(otp.join(""));
  };

  const resendOtpHandler = () => {
    if (!resendDisabled) {
      sendOtpHandler("resend");
    }
  };

  const getIsDisabled = () => {
    if (otp.join("")?.length === 4) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <div className="otp-text">Enter 4 digit otp sent to</div>
      <div className="otp-mobile">{mobileNo}</div>
      <div className="otp-container">
        {otp.map((digit, index) => (
          <input
            key={index}
            type="number"
            value={digit}
            onChange={(e) => handleInputChange(index, e.target.value)}
            className="otp-input"
            ref={inputRefs[index]}
          />
        ))}
      </div>
      <Button
        className="otp-button"
        disabled={getIsDisabled()}
        fluid
        color="black"
        onClick={submitOtpHandler}
        loading={loading}
      >
        {"Next"}
        {/* {btnText} */}
      </Button>
      <div className="resend-link" onClick={resendOtpHandler}>{`Resend OTP ${
        resendDisabled ? `in ${timer}s` : ""
      }`}</div>
    </>
  );
};

export default OtpScreen;
